export default defineNuxtRouteMiddleware(async (to, from) => {
    try {
        await requestAdminSession()
    } catch {
        try {
            await bootstrapAdminOrganization()
        } catch {
            return navigateTo('/')
        }
    }
})

async function requestAdminSession() {
    return await $fetch('/admin/auth/me', {
        baseURL: useApiBaseURL(),
        credentials: 'include',
    })
}

async function bootstrapAdminOrganization() {
    return await $fetch('/admin/auth/bootstrap-organization', {
        method: 'POST',
        baseURL: useApiBaseURL(),
        credentials: 'include',
    })
}
